import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

import { useLocale } from "context/locale"

import RoundedWrapper from "components/RoundedWrapper"
import Button from "components/Button"

import { fadeAnimation } from "utils"

const Positions = ({ data, positions }) => {
  const { t } = useLocale()

  return positions?.length > 0 ? (
    <section className="careers-positions" id="positions">
      <RoundedWrapper
        className="careers-positions__wrapper"
        color="gray"
        bgColor="blue"
      >
        <motion.div {...fadeAnimation}>
          <h2>{data?.careersPositionHeading}</h2>
          <div
            dangerouslySetInnerHTML={{ __html: data?.careersPositionText }}
          />
        </motion.div>

        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="careers-positions__table">
              {positions?.map((item, index) => (
                <motion.div
                  className="careers-positions__item"
                  key={index}
                  {...fadeAnimation}
                >
                  <div className="row align-items-md-center">
                    <div className="col-xl-5 col-md-4">
                      <p>
                        <span>Who</span>
                        <strong>{item.title}</strong>
                      </p>
                    </div>
                    <div className="col-md-4">
                      <p>
                        <span>Where</span>
                        <strong>{item.acfCareer.officeLocation}</strong>
                      </p>
                    </div>
                    <div className="col-xl-3 col-md-4">
                      <div className="careers-positions__item-cta">
                        <Button
                          to={
                            item.language.code === "PL"
                              ? `/pl/o-nas/kariera/${item?.slug}`
                              : `/company/career/${item?.slug}`
                          }
                          className="button--small"
                        >
                          {t("More details")}
                        </Button>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </RoundedWrapper>
    </section>
  ) : null
}

export default Positions
